/**
 * Tags PLP grid rows (product-only vs promo) and syncs product card heights to banner images on desktop.
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
  const OVERFLOW_TOLERANCE = 1;

  function debounce(fn, wait) {
    let timeout;
    return function debounced(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function groupByOffsetTop(items) {
    const rows = [];
    let currentRow = [];
    let lastTop = null;

    items.forEach((item) => {
      const top = item.offsetTop;
      if (lastTop !== null && top > lastTop) {
        rows.push(currentRow);
        currentRow = [];
      }
      currentRow.push(item);
      lastTop = top;
    });

    if (currentRow.length) {
      rows.push(currentRow);
    }

    return rows;
  }

  function cleanupPromoCard(card) {
    if (!card) {
      return;
    }
    card.classList.remove('product-card--promo-row-sync', 'product-card--promo-row-overflow');
    card.style.removeProperty('--promo-image-height');
  }

  function setRowType(listItem, hasPromotion) {
    listItem.classList.toggle('grid-item--promo-row', hasPromotion);
    listItem.classList.toggle('grid-item--product-row', !hasPromotion);
  }

  function applyPromoSync(card, promoHeight) {
    card.classList.add('product-card--promo-row-sync');
    card.classList.remove('product-card--promo-row-overflow');
    card.style.setProperty('--promo-image-height', `${promoHeight}px`);

    const overflows = card.scrollHeight > promoHeight + OVERFLOW_TOLERANCE;
    card.classList.toggle('product-card--promo-row-overflow', overflows);

    if (overflows) {
      card.style.removeProperty('--promo-image-height');
    }
  }

  function syncPromotionRows() {
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('products')) {
      return;
    }

    const isDesktop = DESKTOP_MQ.matches;
    const rowItems = [...grid.children].filter((child) => child.matches('li.columns'));
    const rows = groupByOffsetTop(rowItems);

    rows.forEach((items) => {
      const promoItem = items.find((li) => li.classList.contains('promotion-column'));
      const promoFigure = promoItem?.querySelector('.product-card-promotion figure.aspect-ratio');
      const promoHeight = isDesktop && promoItem ? promoFigure?.offsetHeight || 0 : 0;

      items.forEach((li) => {
        const card = li.querySelector('.product-card');
        const hasPromotion = Boolean(promoItem);

        setRowType(li, hasPromotion);

        if (!hasPromotion || !isDesktop || !promoHeight) {
          cleanupPromoCard(card);
          return;
        }

        if (card) {
          applyPromoSync(card, promoHeight);
        }
      });
    });
  }

  function scheduleSync() {
    window.requestAnimationFrame(() => {
      syncPromotionRows();
    });
  }

  function observeBannerImages(grid) {
    grid.querySelectorAll('.promotion-column figure.aspect-ratio img').forEach((img) => {
      if (img.complete) {
        return;
      }
      img.addEventListener('load', scheduleSync, { once: true });
    });
  }

  let resizeObserver = null;

  function bindResizeObserver(grid) {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    if (resizeObserver) {
      resizeObserver.disconnect();
    }
    resizeObserver = new ResizeObserver(debounce(scheduleSync, 150));
    grid.querySelectorAll('.promotion-column figure.aspect-ratio').forEach((figure) => {
      resizeObserver.observe(figure);
    });
  }

  function init() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return;
    }

    scheduleSync();
    observeBannerImages(grid);
    bindResizeObserver(grid);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('product-grid:updated', init);
  document.addEventListener('lazyloaded', (event) => {
    if (event.target.closest?.('.promotion-column')) {
      scheduleSync();
    }
  }, true);
  window.addEventListener('resize', debounce(scheduleSync, 150));
  DESKTOP_MQ.addEventListener('change', scheduleSync);
})();
